import { Injectable } from '@angular/core';
import 'bingmaps';
import { Subject } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BingApiLoaderService {
    readonly onMapsApiLoaded = new Subject();
    get isMapsApiLoaded(): boolean {
        return this.hasMapsApiLoaded;
    }

    private url = 'https://www.bing.com/api/maps/mapcontrol?callback=loadMap&key=';
    private hasMapLoadBeenRequested = false;
    private hasMapsApiLoaded = false;

    loadMaps(): void {
        if (this.hasMapsApiLoaded) {
            this.onMapsApiLoaded.next(undefined);
            return;
        }

        if (this.hasMapLoadBeenRequested) {
            return;
        }

        this.hasMapLoadBeenRequested = true;
        const node = document.createElement('script');
        node.src = `${this.url}${environment.bingMapsApiKey}`;
        node.type = 'text/javascript';
        node.async = true;
        node.defer = true;
        (window as any)['loadMap'] = () => {
            this.hasMapsApiLoaded = true;
            this.onMapsApiLoaded.next(undefined);
        };

        document.getElementsByTagName('head')[0].appendChild(node);
    }

    /**
     * Adds address auto suggestion onto a component.
     * @param searchBoxId HTML ID of the text input used to search.
     * @param suggestionContainerId HTML ID of the container that will display the results.
     * @param callback Callback function to handle the result.
     * @param map If using a map, the map reference.
     */
    addAutoSuggest(
        searchBoxId: string,
        suggestionContainerId: string,
        callback: (result: Microsoft.Maps.ISuggestionResult) => void,
        map?: Microsoft.Maps.Map
    ): void {
        if (!this.hasMapsApiLoaded) {
            throw Error("You should first load the the map and make sure it's loaded with onMapsApiLoaded.");
        }

        Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', {
            callback: () => {
                const options = {
                    maxResults: 4,
                    map: map,
                    placeSuggestions: !!map,
                    countryCode: 'CH'
                };
                const asManager = new Microsoft.Maps.AutosuggestManager(options);

                asManager.attachAutosuggest(`#${searchBoxId}`, `#${suggestionContainerId}`, callback);
            }
        });
    }
}
